<template lang="pug">
    simple-modal-layout.flag-content-modal(v-bind="$attrs" ref="simpleModal" confirmButtonText="Submit" :disableButtons="sent" @approve="submit")
        template(v-slot:section)
            template(v-if="sent")
                .flag-content-modal-title Your report has been sent
            template(v-else)
                .flag-content-modal-title Why do you want to flag this content?
                .flag-content-modal-content
                    radio-select-field(v-model='reason' :options='reasons' mode='compact')

</template>

<script>
import FlaggedContentService from '../../services/flagged-content-service'

const REASONS = Object.entries(window.addiesaas.gotmehookd.flaggedContent.reasons).map(([value, label]) => ({ label, value}))

export default {
    name: 'flag-content-modal',

    props: {
        post: {
            type: Object,
            required: true,
        },
    },

    data() {
        return {
            sent: false,
            reason: 'Abuse',
            reasons: REASONS,
        }
    },

    methods: {
        async submit({success}) {
            await FlaggedContentService.send({
                post_id: this.post.id,
                reason: this.reason,
            })

            this.sent = true

            setTimeout(() => {
                success()
            }, 2000)
        },
    },
}
</script>
